export default __webpack_public_path__ + "static/media/borrow.b2fb236a.png";